import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {addRegionSlugToQuery} from "../../helpers/friendly_offer_list/add_region_slug_to_query";
import {buildOfferListUrl} from "../../helpers/offer_list_url/build_offer_list_url";
import {fetchSelectedRegionById} from "./offer_list_selected_data_actions";

export const redirectToFriendlyUrl = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    let query = ctx.route.query;
    // update region-slug if necessary
    const regionId = parseInt(query.region as string, 10);
    if (Number.isFinite(regionId)) {
        const region = await dispatch(fetchSelectedRegionById(ctx.meta, regionId));
        if (region) {
            // update query's `region` field (if needed)
            query = addRegionSlugToQuery(query, region);
        }
    }
    dispatch(enable301ResponseState(buildOfferListUrl(query)));
    return false; // stop fetching
};
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {enable301ResponseState} from "@pg-mono/response-state";

import {IRPRequestMeta} from "../../../app/rp_request_meta";
import {addRegionSlugToQuery} from "../../helpers/friendly_offer_list/add_region_slug_to_query";
import {buildOfferListUrl} from "../../helpers/offer_list_url/build_offer_list_url";
import {fetchSelectedRegionById} from "./offer_list_selected_data_actions";

export const redirectToFriendlyUrl = (ctx: IFetchContext<IRPRequestMeta>) => async (dispatch: Dispatch) => {
    let query = ctx.route.query;
    // update region-slug if necessary
    const regionId = parseInt(query.region as string, 10);
    if (Number.isFinite(regionId)) {
        const region = await dispatch(fetchSelectedRegionById(ctx.meta, regionId));
        if (region) {
            // update query's `region` field (if needed)
            query = addRegionSlugToQuery(query, region);
        }
    }
    dispatch(enable301ResponseState(buildOfferListUrl(query)));
    return false; // stop fetching
};
